/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import ProviderSubscriptionRoutes from './provider-subscription.routes';
import ProviderSubscriptionDirective from './provider-subscription.directive';
import ProviderSubscriptionTableConfig from './provider-subscription-table.config';

export default angular.module('tektelic.providerSubscription', [])
    .config(ProviderSubscriptionRoutes)
    .directive('tkProviderSubscription', ProviderSubscriptionDirective)
    .factory('providerSubscriptionTableConfig', ProviderSubscriptionTableConfig)
    .name;



// WEBPACK FOOTER //
// ./src/app/provider/subscription/index.js